import { render } from "./CPointer.vue?vue&type=template&id=2b985790"
import script from "./CPointer.vue?vue&type=script&lang=js"
export * from "./CPointer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tung/Documents/GitHub/cc-faq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__